import React from 'react';

const TabMenu = (props) => {
  const {activeSection, children, className} = props;
  return (
    <div className={`tab-menu-wrapper ${className}`}>
      <ul className="tab-menu">
        {children.map((tab, idx) =>
          <li key={`tab${idx}`} className={activeSection === tab.props.name && 'active'}>
            {tab}
          </li>
        )}
      </ul>
    </div>
  );
};

TabMenu.propTypes = {
  activeSection: React.PropTypes.string.isRequired,
  children: React.PropTypes.node.isRequired,
  className: React.PropTypes.string,
};

export default TabMenu;



// WEBPACK FOOTER //
// ./src/component/Navigation/TabMenu.jsx